import React, { Component } from "react";
import { reduxForm } from "redux-form";
import PropTypes from "prop-types";
import { FormattedMessage, intlShape, injectIntl } from "react-intl";

import TextField from "modules/forms/fields/text-field";
import { validateConfirmEmail } from "modules/utils/validations";

export const FORM_NAME = "confirm-email";

class ConfirmEmailForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onResendCode: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    onChangeEmail: PropTypes.func.isRequired
  };

  render() {
    const { onSubmit, handleSubmit, onResendCode, onChangeEmail } = this.props;
    return (
      <form className="signUpForm" onSubmit={handleSubmit(onSubmit)}>
        <p>
          <FormattedMessage
            id="sign-up.check-email"
            values={{
              break: <br />
            }}
          />
        </p>
        <TextField
          name="email"
          autoComplete="email"
          disabled={true}
          placeholder="sign-up.email"
          onChange={onChangeEmail}
        />
        <TextField name="code" placeholder="sign-up.code" />
        <footer>
          <button className="Button--wide" type="submit">
            <FormattedMessage id="sign-up.confirm" />
          </button>
          <button
            className="Button--wide space"
            type="button"
            onClick={ev => {
              ev.preventDefault();
              onResendCode();
            }}
          >
            <FormattedMessage id="sign-up.resend-code" />
          </button>
        </footer>
      </form>
    );
  }
}
export default injectIntl(
  reduxForm({ form: FORM_NAME, validate: validateConfirmEmail })(
    ConfirmEmailForm
  )
);



// WEBPACK FOOTER //
// ./src/modules/auth/confirm-email-form.js